

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import axios from 'axios';

@Injectable({
  providedIn: 'root'
})
export class FileConversionServiceService {




  constructor() { }
  async getBase64FromUrl(url: string): Promise<string> {
    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      const mimeType = this.getMimeType(url);
      const base64String = await this.convertBlobToBase64(blob, mimeType);
      return base64String;
    } catch (error) {
      console.error('Error fetching the file from URL:', error);
      throw new Error('Failed to fetch file from URL');
    }
  }

  private getMimeType(url: string): string {
    const extension = url.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'pdf':
        return 'application/pdf';
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg';
      case 'png':
        return 'image/png';
      default:
        return 'application/octet-stream';
    }
  }

  private convertBlobToBase64(blob: Blob, mimeType: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Data = reader.result as string;
        const base64String = `data:${mimeType};base64,${base64Data.split(',')[1]}`;
        resolve(base64String);
      };
      reader.onerror = error => {
        console.error('Error reading the Blob as Base64:', error);
        reject('Failed to convert Blob to Base64');
      };
      reader.readAsDataURL(blob);
    });
  }
}
